import { SP_WIDTH } from "../config";

export const isSpSize = () => {
  return window.innerWidth <= SP_WIDTH;
};
